import script from "./rec-tabbed-content.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-tabbed-content.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__